import Vue from 'vue'
const operators = require('@/assets/js/operators.json')
const expressionRegex = /({.*})(>=|!=|<=|=|>|<)(.*)/g

class Expression {
	leftHandVariable = null
	operator = null
	rightHandVariable = null
	rightHandConstant = null
	customExpression = null
	
	constructor (expression, allVariables) {
		let isStandard = this.extractExpressionComponents(expression, allVariables)
		if (!isStandard) this.customExpression = expression
	}

	get expression () {		
		return (this.leftHandVariable ? this.leftHandVariable.name : '') + (this.operator ? this.operator.name : '') + ((this.rightHandVariable ? this.rightHandVariable.name : false) || this.rightHandConstant || '')
	}

	get isValid () {
		return this.leftHandVariable && this.operator && (this.rightHandVariable || (this.rightHandConstant != null && this.rightHandConstant.length))
	}

	// split up each components of an expression
	extractExpressionComponents(expression = '', allVariables) {
		// get groups
		let groups = Array.from(expression.matchAll(expressionRegex))
		if (!groups.length || groups.length && groups[0].length != 4) { console.log('invalid expression: ' + expression); return false }
		else {
			groups = groups[0]
			if (!this.setLeftHand(groups[1], allVariables)) return false
			if (!this.setOperator(groups[2], this.leftHandVariable)) return false
			if (!this.setRightHand(groups[3], allVariables)) return false
			return true
		}
	}

	setLeftHand (content, allVariables) {
		if (allVariables[content]) {
			Vue.set(this, 'leftHandVariable', allVariables[content])
			return true
		} else {
			console.log('invalid expression, left hand variable unknown: ' + content)
			return false
		}
	}

	setOperator (content) {
		let operator = operators.find(o => o.name === content && o.validFor.indexOf(this.leftHandVariable.type.toLowerCase()) > -1)
		if (operator) {
			Vue.set(this, 'operator', operator)
			return true
		} else {
			console.log('invalid expression, invalid operator for variable type ' + this.leftHandVariable.type + ' provided: ' + content)
			return false
		}
	}

	setRightHand (content, allVariables) {
		if (allVariables[content]) {
			this.rightHandConstant = null
			Vue.set(this, 'rightHandVariable', allVariables[content])
			return true
		} else {
			Vue.set(this, 'rightHandVariable', null)
			Vue.set(this, 'rightHandConstant', content)
			return true
		}
	}

	setCustomExpression (expression) {
		this.customExpression = expression
		this.leftHandVariable = null
		this.operator = null
		this.rightHandVariable = null
		this.rightHandConstant = null
	}
}

export default Expression